module.exports = __webpack_public_path__ + "img/service-parts-display-parallax-cjdr.60951b23.jpg";